import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

/**
 * 定义 Footer 组件
 */
class Atlas extends React.PureComponent {
    static propTypes = {
        atlasModuleData: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { atlasModuleData } = this.props;

        return (
            <div className={styles.atlas}>
                <div className={styles.atlasHead}>实拍图集</div>
                <div className={styles.atlasContent}>
                    <div className={styles.bothSides}>
                        {atlasModuleData.slice(0, 2).map((item, index) => {
                            return (
                                <div key={index} className={styles.bothSidesBox}>
                                    <a href={item.url} target="_blank">
                                        {item?.thumbnails?.image?.[0]?.url && (
                                            <img
                                                className={styles.bothSidesPic}
                                                src={formatImage(item.thumbnails.image[0].url || '', 210, 170)}
                                            />
                                        )}
                                        <div className={styles.bothSidesText}>{item.title}</div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.midPicBox}>
                        {atlasModuleData.slice(2, 3).map((item, index) => {
                            return (
                                <a key={index} href={item.url} target="_blank">
                                    {item?.thumbnails?.image?.[0]?.url && (
                                        <img
                                            className={styles.midPic}
                                            src={formatImage(item.thumbnails.image[0].url || '', 650, 350)}
                                        />
                                    )}
                                    <div className={styles.midPicText}>{item.title}</div>
                                </a>
                            );
                        })}
                    </div>
                    <div className={styles.bothSides}>
                        {atlasModuleData.slice(3, 5).map((item, index) => {
                            return (
                                <div key={index} className={styles.bothSidesBox}>
                                    <a href={item.url} target="_blank">
                                        {item?.thumbnails?.image?.[0]?.url && (
                                            <img
                                                className={styles.bothSidesPic}
                                                src={formatImage(item.thumbnails.image[0].url || '', 210, 170)}
                                            />
                                        )}
                                        <div className={styles.bothSidesText}>{item.title}</div>
                                    </a>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Atlas);
